import React from 'react';
import email from '../images/email.png';
import phone from '../images/phone.png';

const Contact = () => {
  return (
    <section className="contact">
      <div className="container">
        <div className="contact__links">
          <a href="mailto:info@fix-it-all-scotland.com" className="contact__item">
            <img src={email} alt="Email" className="contact__icon" />
            <span className="contact__text">info@fix-it-all-scotland.com</span>
          </a>
          <a href="tel:+447886890813" className="contact__item">
            <img src={phone} alt="Phone" className="contact__icon" />
            <span className="contact__text">07886 890 813</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
